import * as React from "react";
import { AnyAction } from "redux";
import { useStore, useSelector } from "react-redux";
import { StoreState } from "../models/states/StoreState";
import { PageModel } from "../models/PageModel";
import { startSimulationAsync } from "../simulator/simulatePages";

const pageSelector = (state: StoreState) => state.interview.navigation.currentPage;

export default function useSimulatedPages() {
    const [simulating, setSimulating] = React.useState(true);
    const [simulatedPages, setSimulatedPages] = React.useState([]);
    const currentPage = useSelector(pageSelector);
    const store = useStore<StoreState, AnyAction>();

    React.useEffect(() => {
        setSimulatedPages([]);

        function onMessage({ data: { type, pages, error } }) {
            if (error) console.log(error);
            if (type === "done") setSimulatedPages(pages);
            setSimulating(false);
        }

        if (typeof Worker !== "undefined") {
            // If web workers are supported.
            setSimulating(true);

            const worker = new Worker("../simulator/worker.ts");
            worker.addEventListener("message", onMessage);
            worker.postMessage({ type: "simulate", initialState: store.getState() });

            return () => {
                worker.removeEventListener("message", onMessage);
            };
        }

        // If web workers are not supported, use an async function instead.
        startSimulationAsync(store.getState())
            .catch((ex) => {
                if (ex) console.log(ex);
            })
            .then((pages: PageModel[]) => {
                setSimulatedPages(pages);
                setSimulating(false);
            });

        // If web workers are not supported, give up.
        setSimulating(false);
        return undefined;
    }, [store, currentPage]);

    return { simulatedPages, simulating };
}
